var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPacientes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pacientes_svg__cls-1",
    d: "M96.24 8.26a88 88 0 1088 88 88 88 0 00-88-88zm0 161.14a73 73 0 01-56.14-26.3c12.9-18.59 33.26-29.17 56.52-29.17a66.25 66.25 0 0145.52 17.89 7.4 7.4 0 1010-10.88 82.46 82.46 0 00-31-18 35.86 35.86 0 10-50.83.19A80.7 80.7 0 0031.38 130a73.15 73.15 0 1164.86 39.4zm-.59-70.91a20.75 20.75 0 1120.74-20.75 20.78 20.78 0 01-20.74 20.75z"
  })));
}

export default SvgPacientes;